export const triggerHaptic = (pattern = 15) => {
  if (typeof window !== 'undefined' && navigator?.vibrate) {
    try {
      navigator.vibrate(pattern);
    } catch (e) {
    }
  }
};

export const hapticImpact = {
  light: 15,          // Легкий тап (категории, быстрые суммы)
  medium: 30,         // Ощутимый тап (переключение вкладок Доход/Расход)
  heavy: 50,          // Тяжелый тап (открытие модалки)
  success: [30, 60, 40], // Двойной приятный вибро-отклик (сохранение)
  error: [50, 50, 50, 50] // Тройной резкий (ошибка валидации)
};